exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-8c20dd32] .el-tabs__header{margin-bottom:0}#equip_table .el-button[data-v-8c20dd32]{padding-left:0;padding-right:0;width:1.13333rem}", ""]);

// exports
